import normalise from './normalise';

const transform = (result) => {
    const products = result.products.map((product) => product.productId);
    return {
        ...result,
        products,
    };
};

const transformer = (results) => results.map(transform);

export default (payload) => normalise(payload, transformer);
